export default function ListItem(props){
    return(
        <li>
            <span>{props.icone} </span>
            <span>{props.texto}</span>
        </li>
    )
};